<style scoped>
    .loadingdefault{
        min-height:100vh;
        background: #F3F3F3;
    }
    .loadingdefault .tipicon{
        margin-left: 22vw;
     }
    .loadingdefault .defaultnote{
        color:#999999;
        text-align: center;
        font-size: 2.2vh;
        margin: 3vh;
    }
    .loader{
        margin: 0 auto;
        text-align: center;
        width: 100%;
        min-height: 100%;
        display: table-cell;
        vertical-align: middle;
    }
    .loading-slide{
        position: relative;
        width: 70%;
        margin: 0 auto;
     }
    .slide{
        position: absolute;
        width: 25%;
        height: 5px;
        background: #FF2824;
        animation: slide 2s infinite;
     }
    .slide:nth-of-type(0n+1){
        opacity: 0.2;
        transform: scale(1.8, 1);
        animation-delay: 0.2s;
     }
    .slide:nth-of-type(0n+2){
        opacity: 0.4;
        transform: scale(1.4, 1);
        animation-delay: 0.1s;
    }
    .slide:nth-of-type(0n+3){
       opacity: 0.8;
    }
    @keyframes slide {
        0% {
            left: 0 
        }
        50% {
            left: 100%
        }
        100% {
            left: 0 
        }
    }
    @-webkit-keyframes slide {
        0% {
            left: 0 
        }
        50% {
            left: 100%
        }
        100% {
            left: 0 
        }
    }
</style> 
<style>
      .sk-wave .sk-rect[data-v-3754eb62]{
      background: #6F7DB8
  }
</style>

<template>
  <div class="loadingdefault flexcenter">
        <div> 
            <div class="flexcenter imgbox">
                <!-- <img src="../assets/default/loading.gif" alt="icon" class="tipicon"> -->
                <!-- <vue-loading spinner="wave"></vue-loading> -->
                <div class="loader">
                    <div class="loading-slide">
                        <div class="slide"></div>
                        <div class="slide"></div>
                        <div class="slide"></div>
                    </div>
                </div>
            </div>
            <div class="defaultnote">{{ msg || msgdefault}}</div>
      </div>
  </div>
</template>

<script>
// import VueLoading from 'vue-simple-loading';
export default {
    name: 'LoadingDefault',
    props: {
        msg : String
    },
    data () {
        return {
            msgdefault:'正在努力加载中~'
        }
    },
    created(){
    },

    components: {
        // VueLoading:VueLoading,
    }
}
</script>

